/*! js-cookie v3.0.1 | MIT */
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e=e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}return function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"})}));


const share_wishlist_btn = '.swym-share-wishlist-email-btn';
var productCardMarkup = `

 {{#products}}
	<div class="product-item" id="wishlist-item-{{ epi }}">
      <form class="product-item__link addtoform"
			method="GET"
			action="{{ du }}">
        <a class="grid-view-item__link grid-view-item__image-container full-width-link" href="{{du}}">
          <span class="visually-hidden hide">{{dt}}</span>
        </a>

<figure class="product-item__image ">
      <div class="primary_images this_id-else">
      <a class="product-item__image product-card__image-wrapper js" href="{{du}}" data-product-id="{{ empi }}">
      <img  class="grid-view-item__image product-item__img product-item__img--always-visible picture__img--cover active lazyautosizes" src="{{iu}}" />
      
      <button title="Click to Remove product from Wishlist" class="skip-btn-style swym-button swym-add-to-wishlist-view-product swym-added swym-loaded" data-product-id="{{ empi}}" data-variant-id="{{ epi }}">
      <svg xmlns="http://www.w3.org/2000/svg" width="20.847" height="18.657" viewBox="0 0 20.847 18.657">
      <path id="heart" d="M9.923,17.657a1.164,1.164,0,0,1-.767-.288c-.8-.7-1.575-1.36-2.257-1.941l0,0A41.973,41.973,0,0,1,1.968,10.8,7.387,7.387,0,0,1,0,5.965,6.2,6.2,0,0,1,1.574,1.728,5.337,5.337,0,0,1,5.544,0,4.992,4.992,0,0,1,8.663,1.076,6.38,6.38,0,0,1,9.923,2.393a6.381,6.381,0,0,1,1.261-1.316A4.992,4.992,0,0,1,14.3,0a5.337,5.337,0,0,1,3.97,1.728,6.2,6.2,0,0,1,1.574,4.237A7.386,7.386,0,0,1,17.879,10.8a41.964,41.964,0,0,1-4.927,4.625c-.683.582-1.457,1.242-2.261,1.945A1.165,1.165,0,0,1,9.923,17.657Z" transform="translate(0.5 0.5)" fill="#800056" stroke="#000" stroke-width="1"/>
      </svg>
	</button>
      </a>
      </div>
      <div class="quick-add">

      </div>
	 <span class="device-only js_trigger_mobile_quickcart"><a href="javascript:;">+</a></span>
</figure>
        <div class="product-item__info">
        <div class="hidden-sizes sizes_radio hidden"></div>
          <header class="product-item--header">
            <h2 class="product-item--title"><a href="{{ du }}">{{dt}}</a></h2>
          </header>
           <div class="col-two-wrapper price-item-wrapper price product-item--price" data-price="">
              <span class="price-item price-item--sale" data-sale-price="">
                {{cu}}{{pr}}
              </span>
          </div>
            
          <div class="color-labels" id="wishlist-colors-{{ epi }}">
          
          </div>





        <div class="sizes-and-btn">
          <div class="options-wrapper">


          </div>

          <button data-product-id="{{empi}}" data-url="{{du}}" data-variant-id="{{epi}}" class="quickshop-hover-add btn add-to-cart {{#isInCart}}added-off{{/isInCart}}">
          <span>Add to Cart</span>
            <span class="hide">
  			     {{#isInCart}}Moved to cart{{/isInCart}}
  			        {{^isInCart}}Move to cart{{/isInCart}}
            </span>
  		    </button>

          </div>
        </div>

    </form>
    </div>
  {{/products}}

`;

var minicookie = Cookies.get("showMiniCart");

// console.log("showMiniCart cookie: " + minicookie);
if (minicookie == 'true') {
  // console.log("show mini cart!");
  Cookies.set("showMiniCart", 'false');
  $(".device-nav-cart").trigger("click");
}

function getVariantInfo(variants){
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []) , variantinfo;
    if(variantKeys.length > 0){
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title"){
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch(err){
    return variants;
  }
}

function swymCallbackFn(){
  // gets called once Swym is ready
  var wishlistContentsContainer = document.getElementById("wishlist-items-container");
  _swat.fetch(
    function(products) {
      // Get wishlist items
      var formattedWishlistedProducts = products.map(function(p){
        // p = SwymUtils.formatProductPrice(p);    // formats product price and adds currency to product Object
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
        var cents = p.pr * 100;
        p.pr = Shopify.formatMoney(cents,Shopify.money_format);
        return p;
      });

//       console.log(formattedWishlistedProducts.length)
      if (formattedWishlistedProducts.length == 0) {
        var $hero = $("#shopify-section-wishlist__hero");
        $hero.find(".shorter.shorter-desktop").removeClass("shorter shorter-desktop");
        var html = `<div class="hero__subtitle  text-center type-d">You haven’t added any favorites to your list yet.<br> To start browsing, <a href="/collections/all">go to our shop</a> and click the heart icon in each product</div>`;
          $(wishlistContentsContainer).html(html);
//         $hero.find(".block-title").after(html);
        $(".wishlist").removeClass("init");
        return;
      }
      else{
        if($('body').hasClass('active-regular-wishlist')){
          $(".wishlist .hero__subtitle").hide();
        }
      }

      // console.log(formattedWishlistedProducts);

      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products: formattedWishlistedProducts});
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      var prod_count = $(wishlistContentsContainer).find('.product-item').length;
      if(!$('body').hasClass('active-regular-wishlist')){
      if(prod_count>3){
        $(wishlistContentsContainer).addClass('wishlist-button-outside').after('<div class="wishlist-btn-wrapper"><button id="share-wishlist-btn">Share Wishlist</button></div>');
      }
      else{
        $(wishlistContentsContainer).html(productCardsMarkup+'<div class="wishlist-btn-wrapper"><button id="share-wishlist-btn">Share Wishlist</button></div>');
      }
      }
      else{
        $(wishlistContentsContainer).html(productCardsMarkup);
      }
//       wishlistContentsContainer.innerHTML = productCardsMarkup + '<button id="share-wishlist-btn">Share Wishlist</button>';
//       $(wishlistContentsContainer).addClass('wishlist-button-outside').after('<button id="share-wishlist-btn">Share Wishlist</button>');

//       console.log(productCardsMarkup)
      
      
      products.map(function(p){

        var p_url = p.du.replace('https://argentwork.com','')+'.js';
                // console.log(p_url)
        jQuery.getJSON(p_url, function(productJson) {
          if (productJson && productJson.variants) {
            variantsAll = JSON.stringify(JSON.stringify(productJson.variants));
            var pi = document.getElementById("wishlist-item-" + p.epi);
            var $productItem = $("#wishlist-item-" + p.epi);

            if (pi) {
              pi.setAttribute("data-variant-dict", variantsAll);
              // console.log(productJson.variants);
              var selectedVariant = productJson.variants.filter(function(v) {
                return v.id == p.epi
              });


              // MAKE THE SWATCHES AND SIZES
              var color = selectedVariant[0].option2;
              var $colors = $("#wishlist-colors-" + p.epi);

              var $colorway = $("#colorway-product-" + p.empi);
              if ($colorway.length) {
                var col = $colorway.attr("data-col-id");
                var others = $("#colorway-collections").find("[data-col-id="+col+"]");

                var $img = $productItem.find(".grid-view-item__image"); // the one that already exists
                $img.attr("data-product-id", p.empi);

                others.each(function() {
                  var vid = $(this).attr("data-product-id");
                  var url = $(this).attr("data-url");
                  var active = false;
                  var selectedVariant = productJson.variants.filter(function(v) {
                    return v.id == p.epi
                  });
                  // console.log(selectedVariant)
                  if (p.empi == vid) {
                    active = true;
                  }

                  // make swatches
                  var clr = $(this).attr("data-color");
                  var swtch = $(this).attr("data-swatch");
                  var style = getSwatchStyle(clr);
                  var cp_price = $(this).attr('data-price');
                  var html = makeSwatch(vid, style, clr, active,productJson.variants,cp_price);
                  $colors.append(html);

                  // make featured images
                  if (vid != p.empi) {
                    var img = $(this).attr("data-image");
                    var imgHTML = `<img class="grid-view-item__image product-item__img picture__img--cover lazyautosizes" src="`+img+`" data-product-id="`+vid+`" />`;
                    $img.after(imgHTML);
                  }


                  // make sizes
                  var sizes = '';
                  var mobilesizes = '';

                  // console.log(p)
                  var product_url = p.du.replaceAll('https://argentwork.com/','').split("/")[1];
                  $(this).find("[data-variant-id]").each(function() {
                    var getsizes = makeSizes($(this).attr("data-stock"), vid, $(this).attr("data-variant-id"), $(this).attr("data-size"), url,p.cprops,selectedVariant[0],p.dt,product_url);
                    sizes = sizes + getsizes.sizes;
                    mobilesizes = mobilesizes + getsizes.mobilesizes;
                  });

                  /*Not needed now, new size selector is there*/
                  $productItem.find(".options-wrapper").append(populateMobileSizes(mobilesizes, vid, active));
                  // $productItem.find(".sizes_radio").append(populateMobileSizes(mobilesizes, vid, active));
                  $productItem.find(".quick-add").append(populateSizes(sizes, vid, active));
                  initSizeSlider();
                })

                $productItem.find(".product-item__swatch").click(function(e) {
                  e.preventDefault();
                  var id = $(this).attr('data-product-id');
                  var $p = $(this).parents(".product-item");
                  $p.find(".product-item__swatch").removeClass("product-item__swatch--active");
                  $(this).addClass("product-item__swatch--active");

                  $p.find(".option--size[data-product-id!="+id+"],.quick-add__back[data-product-id!="+id+"],.product-item__img[data-product-id!="+id+"]").removeClass("active");
                  $p.find(".option--size[data-product-id="+id+"],.quick-add__back[data-product-id="+id+"],.product-item__img[data-product-id="+id+"]").addClass("active");

                });
              } else {
                // no colorway...

                // make swatch
                var style = getSwatchStyle(color);
                var html = makeSwatch(p.emi, style, color, true,productJson.variants,p.pr);
                $colors.append(html);

                // make sizes
                var sizes = '';
                var mobilesizes = '';

                var product_url = p.du.replaceAll('https://argentwork.com/','').split("/")[1];
                productJson.variants.map(function(v) {
                  if (v.option2 == color) {
                    var getsizes = makeSizes(v.inventory_quantity, p.empi, v.id, v.option1, p.du,p.cprops,v,p.dt,product_url);
                    sizes = sizes + getsizes.sizes;
                    mobilesizes = mobilesizes + getsizes.mobilesizes;
                  }
                });

                /*Not needed now, new size selector is there*/
                $productItem.find(".options-wrapper").append(populateMobileSizes(mobilesizes, p.empi, true));
                // $productItem.find(".sizes_radio").append(populateMobileSizes(mobilesizes, p.empi, true));
                $productItem.find(".quick-add").append(populateSizes(sizes, p.empi, true));
                
                initSizeSlider();

              }




              $productItem.find(".quick-add__button").click(function(e) {
                e.preventDefault();
                changeAddToCartClick($(this));
              })

              $productItem.find(".option-value").click(function(e) {
                e.preventDefault();
                changeAddToCartClickFromMobile($(this));
              })

//               var selectedSize = pi.querySelector(".selected-size");
//               selectedSize.addEventListener('click', function(e) {
//                 e.preventDefault();
//                 var parent  = getClosest(event.target, '.product-item');
//                 var $t = parent.querySelector(".option__values");
//                 if ($t.classList.contains("active")) {
//                   $t.classList.remove("active");
//                   e.target.classList.remove("active");
//                 } else {
//                   $t.classList.add("active");
//                   e.target.classList.add("active");
//                 }
//               }, false);

              $(".wishlist").removeClass("init");

              return p;

              // var u = new vd.VariantDict(variantsAll);
              // console.log(u);
            }
           }
        });
//         console.log(p)
//         _swat.getProductDetails(
//           p,
          
//         );
      });

      var wishlistURL;

      try{
        _swat.generateSharedListURL(null, function(r) {
//           console.log("success share URL: " + r);
          wishlistURL = r;
          var wuri = encodeURIComponent(r);
          var html = `
<div class="share" data-href="`+wishlistURL+`">
<h3 class="type-e">Share</h3>
<div class="share-options">
<a href="mailto:?subject=Argent Favorites&body=`+wuri+`" class="share-icon share-email"><span class="displace">share on email</span></a>
<a href="#" class="share-icon share-facebook"><span class="displace">share on facebook</span></a>
<a href="#" class="share-icon share-twitter"><span class="displace">share on twitter</span></a>
<a href="#" class="share-icon share-pinterest"><span class="displace">share on pinterest</span></a>
<a href="sms://&body=Argent Favorites `+wuri+`" class="share-icon share-sms"><span class="displace">share on sms</span></a>
</div>
</div>  `;

          var $hero = $("#shopify-section-wishlist__hero");
          $hero.find(".block-title").after(html);
          S.share.links($hero);

        }, function() {
          // console.log("error");
          console.log("no shareable link!");
          var html = `
<div class="login-to-share share type-e">
<a href="/account/login">Login</a> to share your wishlist</a>
</div>  `;

          var $hero = $("#shopify-section-wishlist__hero");
          $hero.find(".block-title").after(html);
        })
      }
      catch(ex){
        console.log('ex',ex)
      }



      attachClickListeners();
      // _swat.initShareWishlist();
      // console.log(_swat.generateSharedWishlistURL());

    },
    window._swat.EventTypes.addToWishList
  );
  

 
  
}
if(!window.SwymCallbacks){
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);

function shareWishlist(name,email,note) {
//   _swat.sendEmailWishList(function callback() {
//      // Successfully sent
//      console.log("successfully sent!")
  //   }, 'dev@22pines.com', 'dev@22pines.com', 'Sharing my wishlist for testing...');

  try{
    _swat.sendListViaEmail(
      {
        toEmailId: email,
        fromName: name,
        note: note,
        lid: null, // null when multiple list is not enabled
      },
      function(r) {
        console.log('Email sent!',r);
        $(share_wishlist_btn).text('Email Sent!');
        $('.swym-share-wishlist-input-container').hide();
        $('.wishlist-thankyou-popup').show();
        setTimeout(function(){ 
          $(share_wishlist_btn).text('Send Now');
          $('.swym-input-container').find('.swym-input-has-error').removeClass('swym-input-has-error');
          $('.error-msg').remove();
          $('.swym-share-wishlist-input-container input, .swym-share-wishlist-input-container textarea').val('');
          $('.swym-share-wishlist-input-container').show();
          $('.wishlist-thankyou-popup').hide();
        }, 6000);

      },
      function(r) {
        console.log('Email failed!',r);
      }
    );
  }
  catch(ex)
  {
    console.log('share wishlist',ex)
  }
}


function initSizeSlider(){
  $('.wishlist .product-item').each(function(){
    var ele = $(this);
    var size_slider = ele.find('.product-item__link > .product-item__image > .quick-add > .quick-add__back');
    //                   console.log(size_slider,ele)
    size_slider.each(function(){
      var single_slider =$(this);
      if(single_slider.find('.quick-add__button').length>8){
//         console.log(single_slider, 'wishlist size slier initied')
        if(!single_slider.hasClass('slick-initialized')){
          single_slider.slick(prod_sizes_slider_config).slick('resize');
        }
        else{
          single_slider.slick('unslick').slick(prod_sizes_slider_config).slick('resize');
        }
      }
    })

  })
}

function changeAddToCartClick($t){
  // console.log($t.attr("class"));
  if (!$t.hasClass("quick-add--out-of-stock")) {
    var productId = $t.attr("data-product-id");
    var variantId = $t.attr("data-variant-id");
    var size = $t.attr("data-size");
    var url = $t.attr("data-url");
    $t.addClass("selected").siblings().removeClass("selected");
    // console.log("pro: " + productId);
    // console.log("var: " + variantId);
    var parent  = $t.parents(".product-item").first();
    var prod__handle = $t.attr('data-product_handle'),product_title=$t.attr('data-product_title');
    if (parent) {
      var variant_obj = JSON.parse($t.attr('data-variant'));
      // cart.addItem(new t.CartItem(variant_obj, 1));
      // cart.update();
      var add = parent.find(".add-to-cart");
      // console.log(variant_obj);
      if (add.length) {
        add.attr("data-product-id", productId).attr("data-variant-id", variantId).attr("data-url", url).attr('data-size',size);
        if ($t.is(":visible")) {
          console.log("trigger click???",add);
          // add.trigger("click");
          var items ={
              quantity: 1,
              id:variantId
            };
          variant_obj.handle=prod__handle;
          variant_obj.product_title= product_title;
            $.ajax({
              url: '/cart/add.js',
              dataType: 'json',
              cache: false,
              type: 'post',
              data: items,
              success: function(data) {
                variant_obj.featured_image || (variant_obj.featured_image = {
                  url: variant_obj.featured_image
                }), cart.addItem(new window._cartItem(variant_obj, 1)), cart.update(), $("#quick-cart").addClass("active"),$('html,body').removeClass('disabled-scroll'), $('.full-looks').removeClass('active'), $(".header, .header-wrapper, .collection").addClass("mini-cart-open"),includeJSFile('https://js.getcatch.com/shopify.min.js'), setTimeout(function() {
                      $(".mini-cart").removeClass("active"), $(".header, .header-wrapper, .collection").removeClass("mini-cart-open")
                    }, 5000);
              }
            })
        }
      }

    }
  }
}

function changeAddToCartClickFromMobile($t){
  if (!$t.hasClass("quick-add--out-of-stock")) {
    var parent  = $t.parents(".product-item").first();
    var p = $t.parents('.option--size').first();
    var t = p.find(".selected-size");
    var n = p.find(".option-name-click");
    var size = $t.attr("data-size");
    var product_id = p.attr("data-product-id");
    // console.log("product_id: " + product_id)
    t.html(size);

    $t.addClass("active").siblings(".active").removeClass("active");

    if (t.hasClass("active")) {
      t.trigger("click");
    }
    if (n.length && n.hasClass("active")) {
      n.trigger("click");
    }

    if (parent) {
      var size = parent.find(".quick-add__back[data-product-id="+product_id+"] .quick-add__button[data-size='"+size+"']");
      if (size) {
        size.trigger("click");
      }

    }
  }
}

function onAddToCartClick(e){
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
   {empi: productId, du: du},
   variantId,
   function() {
     // e.target.innerHTML = "<span>Added... </span>";
     // e.target.classList.add("added");
     Cookies.set("showMiniCart", 'true');
     // console.log("Setting? showMiniCart cookie: " + Cookies.set("showMiniCart"));

     /*
     var mini = document.getElementById("quick-cart");
     if (mini) {
       mini.classList.add("active");
       setTimeout(function() {
         mini.classList.remove("active");
       }, 5000)
     } */



     window.location.reload();
     // console.log("Added to cart.");
   },
   function(e) {
     console.log(e);
   }
  );
}


function attachClickListeners(){
  var addToCartButtons = document.getElementsByClassName("add-to-cart");

  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }

  $(".swym-add-to-wishlist-view-product").click(function(e) {
    e.preventDefault();
    var product_id = $(this).attr("data-product-id");
    var variant_id = $(this).attr("data-variant-id");

    _swat.fetch(function(products) {
      var epi = parseInt(variant_id); /* get the selected variant id as a number */
      var empi = parseInt(product_id); /* get the selected product id as a number */
      window._swat.removeFromWishList({"epi": epi,"empi": empi},function(r) {
              console.log('Removed to wishlist',r);
              window.location.reload();
            }
      );
    })
    
    
//     _swat.removeFromWishList({ empi: product_id, epi: variant_id }, function() {
//       window.location.reload();
//     })
  })

  $('body').on('click','#share-wishlist-btn',function(e){
    e.preventDefault();
    $('.swym-share-wishlist-modal').addClass('active')
  })

  $('body').on('click','.swym-close-btn',function(e){
    e.preventDefault();
    $('.swym-share-wishlist-modal').removeClass('active')
  })



  
  let usernameError = true;
  function validateUsername() {
    let fullname = $('#swym-name');
    fullname.removeClass('swym-input-has-error').parents('.swym-input-container').find('.error-msg').remove();
    if (fullname.val().length == '') {
      fullname.addClass('swym-input-has-error');
      fullname.parents('.swym-input-container').find('.error-msg').remove();
      fullname.after('<span class="error-msg" role="alert">Please enter your name</span>');
      usernameError = false;
      $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
      return false;
    }
    else {
      fullname.removeClass('swym-input-has-error');
      $(share_wishlist_btn).removeAttr('disabled').removeClass('swym-disabled');
      fullname.parents('.swym-input-container').find('.error-msg').remove();
      return true;
    }
  }
  let shipping_addressError = true;
  function validateShippingAddress() {
    let shipping_address = $('#swym-note');
    shipping_address.removeClass('swym-input-has-error').find('.error-msg').remove();
    if (shipping_address.val().length == '') {
      shipping_address.addClass('swym-input-has-error');
      shipping_address.parents('.swym-input-container').find('.error-msg').remove();
      shipping_address.after('<span class="error-msg" role="alert">Please enter a shipping address</span>');
      shipping_addressError = false;
      $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
      return false;
    }
    else {
      shipping_address.removeClass('swym-input-has-error');
      shipping_address.parents('.swym-input-container').find('.error-msg').remove();
      $(share_wishlist_btn).removeAttr('disabled').removeClass('swym-disabled');
      return true;
    }
  }
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  function checkemail(){
    var email = $("#swym-email");
    var email_parent = email.parents('.swym-input-container');
    if(email.val().length==0){
      email_parent.addClass('swym-input-has-error');
      email_parent.find('.error-msg').remove();
      $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
      email.after('<span class="error-msg" role="alert">Please enter a valid email address</span>');
      return false;
    }
    else if(!validateEmail(email.val())){
      console.log(validateEmail(email.val()))
      email_parent.addClass('swym-input-has-error');
      email_parent.find('.error-msg').remove();
      $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
      email.after('<span class="error-msg" role="alert">Please enter a valid email address</span>');
      return false;
    }
    else{
      $('.swym-input-has-error').removeClass('swym-input-has-error');
      $('.error-msg').remove();
      $(share_wishlist_btn).removeAttr('disabled').removeClass('swym-disabled');
      return true;
    }
  }
  
  $('body').on('click',share_wishlist_btn,function(e){
    e.preventDefault();
    
    var email = $("#swym-email");
    var fullname = $("#swym-name");
    var shipping_address=$("#swym-note");
    if(validateUsername()==true && checkemail()== true && validateShippingAddress()== true){
      shareWishlist(fullname.val(), email.val(),$('#swym-note').val())
    }
    else{
      $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
    }
    
  })

  $('body').on('keyup blur','.swym-share-wishlist-email',function(e){
    e.preventDefault();
    var email = $(this);
    var email_parent = email.parents('.swym-input-container');
    if(email.val().length==0 && !validateEmail(email.val())){
      email_parent.addClass('swym-input-has-error');
      email_parent.find('.error-msg').remove();
      email.after('<span class="error-msg" role="alert">Please enter a valid email address</span>');
      $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
    }
    else{
//       console.log(validateEmail(email.val()))
      if(!validateEmail(email.val())){
        email_parent.addClass('swym-input-has-error');
        email_parent.find('.error-msg').remove();
        $(share_wishlist_btn).attr('disabled','disabled').addClass('swym-disabled');
        email.after('<span class="error-msg" role="alert">Please enter a valid email address</span>');
      }
      else{
        email_parent.removeClass('swym-input-has-error');
        email_parent.find('.error-msg').remove();
        $(share_wishlist_btn).removeAttr('disabled').removeClass('swym-disabled');
      }
    }
  })

  $('body').on('keyup blur','#swym-name',function(e){
    validateUsername();
  })
  $('body').on('keyup blur','#swym-note',function(e){
    validateShippingAddress();
  })
  
}



var getClosest = function (elem, selector) {

	// Element.matches() polyfill
	if (!Element.prototype.matches) {
	    Element.prototype.matches =
	        Element.prototype.matchesSelector ||
	        Element.prototype.mozMatchesSelector ||
	        Element.prototype.msMatchesSelector ||
	        Element.prototype.oMatchesSelector ||
	        Element.prototype.webkitMatchesSelector ||
	        function(s) {
	            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
	                i = matches.length;
	            while (--i >= 0 && matches.item(i) !== this) {}
	            return i > -1;
	        };
	}

	// Get the closest matching element
	for ( ; elem && elem !== document; elem = elem.parentNode ) {
		if ( elem.matches( selector ) ) return elem;
	}
	return null;

};

function string_to_slug (str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to   = "aaaaeeeeiiiioooouuuunc------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

function getSwatchStyle(color) {
//   console.log('color',color)
  if(color != null){
    var slug = string_to_slug(color);
    //   var slug = color;
    var swatch = $("#wishlist-swatch-color-" + slug);
    if (swatch.length) {
      var swatchImg = swatch.attr("data-swatch");
      var style = "background-image: url("+swatchImg+")";
    } else {
      var style = '';
    }
    return style;
  }
  else{
    return "";
  }

}

function makeSwatch(id, style, color, active,variants,pro_price) {

  // console.log(variants,single_variant,id)
  var checked = ''
  if (active == true) {
    active = 'product-item__swatch--active';
    checked = 'checked';
  } else {
    active = '';
  }
// ${Shopify.formatMoney(single_variant[0].price,Shopify.money_format)}
  var html = ` <div class="color-label" data-price="${pro_price}">
              <label for="swatch-`+id+`"
                class="product-item__swatch `+active+`" data-product-id="`+id+`">
                <input
                  type="radio"
                  id="swatch-`+id+`"
                  class="product-item__swatch-selector"
                  name="variant"
                  value="`+id+`"
                  data-variant-dict='${JSON.stringify(variants)}'
                  `+checked+` />
                <div
                  class="color" style="`+style+`"></div>

              </label>
              <span class="color-name type-e"  id="wishlist-color-`+id+`">`+color+`</span>
            </div>`;
  return html;
}

function makeSizes(inventory, id, vid, label, url,cprops,variant,product_title,prod_handle) {
  var invent_class = '';
  var c_vid = (cprops != undefined && cprops.vid != undefined)?cprops.vid:false;
  var size_selected = (cprops != undefined)?cprops.size:false;
  var active_size = '';
  if(size_selected){
    active_size = (label==size_selected && c_vid == vid)?' wishlist-selected-size ':'';
  }
  if (inventory < 1) {
    invent_class = " quick-add--out-of-stock"
  }

  var variant_att = "data-variant='"+JSON.stringify(variant)+"' data-variant-title='"+variant.title+"' data-product_title='"+product_title+"' data-product_handle='"+prod_handle+"'";
  var sizes = '<div class="quick-add__button '+active_size+invent_class+'" data-product-id="'+id+'"  '+variant_att+' data-variant-id="'+vid+'" data-url="'+url+'" data-size="'+label+'">' + label + '</div>';
  var mobilesizes = '<label class="option-value " data-size="'+label+'"><input class="option__input" type="radio" name="size" value="'+label+'"><div class="option-value__label" data-size="'+label+'">'+label+'</div></label>';

  return { sizes: sizes, mobilesizes: mobilesizes }
}

function populateMobileSizes(mobilesizes, id, active) {
  if (active == true) {
    active = ' active';
  } else {
    active = '';
  }
  var html = `<div
    class="option--size`+active+`"
    data-option-index="1"
    data-option-is-swatch="false"
    data-option-is-master="false"
    data-product-id="`+id+`">

    <div class="option__values-wrapper type-e">
       <div class="selected-size">Select a Size</div>
       <div class="option__values">`+mobilesizes+`</div>
   </div>
  </div>`;

  return html;
}

function populateSizes(sizes, id, active) {
  if (active == true) {
    active = ' active';
  } else {
    active = '';
  }
  var html = `<div class="quick-add__back type-e`+active+`" id="wishlist-item-`+id+`-sizes" data-product-id="`+id+`">`+sizes+`</div>`;
  return html;
}
